import {
  BusinessEntitlementConfig,
  EntitlementName,
} from "@shared/types/localTypes/entitlements.ts";
import stringUtils from "@shared/utils/string-utils.ts";

const entitlement: BusinessEntitlementConfig = {
  entitlementName: EntitlementName.VIRTUAL_PURCHASED_STORAGE,
  displayName: "Data Storage",
  isCustomerFacing: true,
  cardConfig: {
    isTrial: () => false,
    icon: "data-storage-icon",
    title: "Data Storage",
    valueTransformer: (value) => {
      if (value === "N/A" || value === "Annual Contract") {
        return value;
      }
      return stringUtils.formatUsageWithUnit(value) + "/month";
    },
    valueTransformerSH: (value) => {
      return {
        display: value !== "N/A",
        value: stringUtils.formatUsageWithUnit(value),
        units: "Per month",
      };
    },
  },
};

export default entitlement;
